import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPencilLine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"pencil-line, signature, write"} maskId="square-filled-radius-0-stroke-1-IconPencilLine"><path d="M17 1.79285L2 16.7928V22H7.20711L22.2071 6.99995L17 1.79285Z" fill="currentColor"/><path d="M11 21V22H22V21H11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPencilLine;
